module.exports = __webpack_public_path__ + "img/home_img.28ab84c8.png";